import { all, call, put, takeLatest } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';
import { modal } from '../../components/Base/Modal';

function* getAdmins({ payload }) {
  try {
    const { status, data } = yield call(api.admins.getAdmins, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_ADMINS_SUCCESS, payload: data.data });
  } catch (error) {
    yield put({ type: types.GET_ADMINS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getPermissions() {
  try {
    const { status, data } = yield call(api.admins.getPermissions);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PERMISSIONS_SUCCESS, payload: data.data });
  } catch (error) {
    yield put({ type: types.GET_PERMISSIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* postAdmin({ payload, pagination }) {
  try {
    const { status, data } = yield call(api.admins.postAdmin, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_ADMIN_SUCCESS, payload: data });
    yield put({ type: types.GET_ADMINS_START, payload: pagination });
    modal.close();
  } catch (error) {
    yield put({ type: types.POST_ADMIN_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putAdmin({ id, payload, pagination, permissions }) {
  try {
    const { status, data } = yield call(
      api.admins.putAdmin,
      id,
      payload,
      permissions,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_ADMIN_SUCCESS, payload: data });
    yield put({ type: types.GET_ADMINS_START, payload: pagination });
    modal.close();
  } catch (error) {
    yield put({ type: types.PUT_ADMIN_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* deleteAdmin({ payload, pagination }) {
  try {
    const { status, data } = yield call(api.admins.deleteAdmin, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_ADMIN_SUCCESS, payload: data });
    yield put({ type: types.GET_ADMINS_START, payload: pagination });
    modal.close();
  } catch (error) {
    yield put({ type: types.DELETE_ADMIN_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* admins() {
  yield all([
    takeLatest(types.GET_ADMINS_START, getAdmins),
    takeLatest(types.GET_PERMISSIONS_START, getPermissions),
    takeLatest(types.POST_ADMIN_START, postAdmin),
    takeLatest(types.PUT_ADMIN_START, putAdmin),
    takeLatest(types.DELETE_ADMIN_START, deleteAdmin),
  ]);
}
